/**
 * Field Type Normalization Utility
 *
 * Normalizes field type strings from API to internal format.
 * Handles variations like "Multi-choice" → "multichoice"
 */

/**
 * Normalizes field type strings from API to internal format
 * @param fieldType - The raw field type string from API (e.g., "Multi-choice", "MULTI-CHOICE")
 * @returns Normalized field type string (e.g., "multichoice")
 *
 * @example
 * normalizeFieldType("Multi-choice") // returns "multichoice"
 * normalizeFieldType("MULTI-CHOICE") // returns "multichoice"
 * normalizeFieldType("Text")         // returns "text"
 * normalizeFieldType(undefined)      // returns ""
 */
export const normalizeFieldType = (fieldType: string | undefined): string => {
  if (!fieldType) return '';
  // Convert to lowercase and remove hyphens
  return fieldType.toLowerCase().replace(/-/g, '');
};
